import { ImmunityEffect } from 'game/extended/heros/paladin/immunity/immunity_effect'

export default {
    events: {},
    effects: {
        ImmunityEffect
    },
    requirements: {}
}